/**
 * "Show frames and animation": on by default. Turned off, every frame becomes a plain colored border (1px still, 2px sliding,
 * 3px spinning, the frame's own colors, two at most) so a framed ad is still recognizable but nothing moves or glows.
 * Kept on this device; public/boot.js applies it before the first paint.
 */
export const FRAMES_KEY = 'vc-frames'
export const framesCalm = (): boolean => { try { return localStorage.getItem(FRAMES_KEY) === 'calm' } catch { return false } }
export function applyFramesPref(calm: boolean): void {
  if (calm) document.documentElement.dataset.frames = 'calm'
  else delete document.documentElement.dataset.frames
  try { if (calm) localStorage.setItem(FRAMES_KEY, 'calm'); else localStorage.removeItem(FRAMES_KEY) } catch { /* it still applies for this visit */ }
}
